import styled from "styled-components";

const layoutVars = `
  --container-padding-desktop: 5rem;
  --container-padding-tablet: 4rem;
  --container-padding-mobile: 2rem;
  --container-padding-small: 1rem;
  --menu-width-collapsed: 72px;
`;

export const DefaultContainer = styled.div`
  ${layoutVars}
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  * {
    box-sizing: inherit;
  }
`;

export const ChildrenContainer = styled.main`
  ${layoutVars}
  display: flex;
  flex-direction: column;
  gap: 2rem;
  
  inline-size: 100%;
  max-inline-size: 100%;
  min-height: calc(100vh - 80px);
  
  overflow-x: hidden;
  
  padding: 0.2rem var(--container-padding-desktop) 2rem;
  
  @media (max-width: 1199px) {
    padding: 0.5rem var(--container-padding-tablet) 1.5rem;
    gap: 1.5rem;
  }
  
  @media (max-width: 767px) {
    padding: 0.7rem var(--container-padding-mobile) 1.5rem;
  }
  
  @media (max-width: 479px) {
    padding: 0.1rem var(--container-padding-small) 1rem;
    gap: 1rem;
  }
`;

export const PageTitle = styled.h1`
  margin-block-start: 0.5rem;
  padding: 0;
`;

export const AlignedSection = styled.section`
  margin: 0;
  padding: 0;
`;

export const FullPageContainer = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;